import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { API } from "@/lib/api";
import { DownloadSimple, GraduationCap, EnvelopeSimple, Phone, MapPin } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function ResumeView() {
  const { slug } = useParams();
  const [r, setR] = useState(null);

  useEffect(() => { api.get(`/resumes/${slug}`).then((x) => setR(x.data)).catch(() => setR(false)); }, [slug]);
  if (r === null) return <div className="p-12 text-center text-muted-foreground">Loading…</div>;
  if (r === false) return <div className="p-12 text-center text-muted-foreground">This resume is private or not found.</div>;

  const c = r.content || {};
  const token = localStorage.getItem("ga_token");

  return (
    <div className="min-h-screen bg-muted/40 py-10">
      <div className="mx-auto max-w-3xl px-5">
        <div className="mb-4 flex justify-end">
          <Button className="rounded-full gap-2" onClick={() => window.open(`${API}/resumes/${r.id || slug}/pdf${token ? `?auth=${token}` : ""}`, "_blank")} data-testid="resume-view-download">
            <DownloadSimple size={16} /> Download PDF
          </Button>
        </div>
        <article className="rounded-2xl bg-white p-10 shadow-lg sm:p-14">
          <header className="border-b-2 border-primary pb-5">
            <h1 className="font-heading text-4xl font-semibold text-primary">{c.name}</h1>
            {c.headline && <p className="mt-1 text-lg text-secondary">{c.headline}</p>}
            <div className="mt-3 flex flex-wrap gap-x-5 gap-y-1 text-sm text-neutral-500">
              {c.email && <span className="flex items-center gap-1.5"><EnvelopeSimple size={14} /> {c.email}</span>}
              {c.phone && <span className="flex items-center gap-1.5"><Phone size={14} /> {c.phone}</span>}
              {c.location && <span className="flex items-center gap-1.5"><MapPin size={14} /> {c.location}</span>}
            </div>
          </header>

          {c.summary && <section className="mt-6"><h2 className="font-heading text-lg font-semibold text-secondary">Summary</h2><p className="mt-2 leading-relaxed text-neutral-700">{c.summary}</p></section>}

          {c.experience_bullets?.length > 0 && (
            <section className="mt-6"><h2 className="font-heading text-lg font-semibold text-secondary">Highlights</h2>
              <ul className="mt-2 space-y-1.5 text-neutral-700">{c.experience_bullets.map((b, i) => <li key={i} className="flex gap-2"><span className="text-secondary">•</span> {b}</li>)}</ul>
            </section>
          )}

          {c.education?.length > 0 && (
            <section className="mt-6"><h2 className="font-heading text-lg font-semibold text-secondary">Education</h2>
              <div className="mt-2 space-y-2">
                {c.education.map((e, i) => (
                  <div key={i} className="flex items-start gap-2 text-neutral-700"><GraduationCap className="mt-0.5 text-primary" size={18} />
                    <div><span className="font-medium">{e.institution}</span> — {[e.degree, e.course].filter(Boolean).join(" ")} <span className="text-neutral-400">{e.batch || `${e.start_year}-${e.end_year}`}</span></div>
                  </div>
                ))}
              </div>
            </section>
          )}

          {c.skills?.length > 0 && (
            <section className="mt-6"><h2 className="font-heading text-lg font-semibold text-secondary">Skills</h2>
              <div className="mt-2 flex flex-wrap gap-2">{c.skills.map((s) => <span key={s} className="rounded-full bg-neutral-100 px-3 py-1 text-sm text-neutral-700">{s}</span>)}</div>
            </section>
          )}
        </article>
      </div>
    </div>
  );
}
